<template>
  <div :class="wrapperclass">
    <div class="row">
      <label :class="nolabel ? '' : 'col-form-label ' + labelclass" v-if="nolabel !== true">{{ title || '&nbsp;' }}</label>
      <div :class="nolabel ? 'col-form-input col-12' : 'col-form-input ' + inputclass">
        <select v-show="readonly !== true" :id="id" ref="select" class="form-control form-control-select2" :data-placeholder="placeholder || ' '" v-model="val" :required="required ? true: false" :multiple="multiple || false">
          <option></option>
          <option v-for="option in options" :value="option.Key" :key="option.Key" :disabled="option.Disabled === true">{{ displayField ? option[displayField] : option.Value }}</option>
        </select>
        <input v-if="readonly" type="text" :placeholder="placeholder" class="form-control" :value="valueText" readonly="readonly">
        <label v-if="isValid === false" id="basic-error" class="validation-invalid-label" for="basic">{{ $t('ui.SYS00016') }}</label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SelectBox',
  props: ['id', 'title', 'placeholder', 'value', 'options', 'readonly', 'required', 'inDialog', 'nolabel', 'multiple', 'labelwidth', 'displayField', 'wrapperclass','labelclass','inputclass'],
  data () {
    return {
      val: [],
      isValid: true,
      inited: false
    }
  },
  methods: {
    setFocus () {
      this.$refs.select.focus()
    },
    setValid (val) {
      this.isValid = val

      if (!val) {
        $(this.$refs.select).next('.select2-container').addClass('invalid')
      } else {
        $(this.$refs.select).next('.select2-container').removeClass('invalid')
      }
    },
    isFieldValid () {
      return !this.required || (this.required && (this.val && this.val.length > 0))
    },
    resetValue () {
      this.isValid = true
      this.val = []
      $(this.$refs.select).val(this.val).trigger('change')
    },
    init () {
      this.val = this.value || []

      if ($(this.$refs.select).length === 0) return

      // Init dropdown
      if ($(this.$refs.select).is(':visible')) {
        this.initSelect2()
      }
    },
    initSelect2 () {
      if (!this.inited && this.$refs.select && $(this.$el).is(':visible') && !this.readonly) {
        var opt = {
          allowClear: false //!this.multiple
        }

        if (this.inDialog) {
          opt.dropdownParent = $(this.$el).closest('.modal')
        }
        $(this.$refs.select).select2(opt).on('select2:selecting', $.proxy(function (e) {
          this.previousVal = this.val
        }, this)).on('select2:select', $.proxy(function (e) {
          this.$emit('input', e.params.data.id, this.previousVal, this)
        }, this)).on('select2:unselect', $.proxy(function (e) {
          this.$emit('input', null, this.previousVal, this)
        }, this)).on('select2:unselecting', function () {
          $(this).data('unselecting', true)
        }).on('select2:opening', function (e) {
          if ($(this).data('unselecting')) {
            $(this).removeData('unselecting')
            e.preventDefault()
          }
        })
        let vm = this
        if ($(this.$refs.select).find("option[value='" + vm.value + "']").length){
          $(this.$refs.select).val(this.value).trigger('change');
        }else{
          this.$emit('input', null, null, this)
        }

        this.inited = true
      }
    }
  },
  computed: {
    valueText () {
      var v = null
      if (this.val && this.options) {
        $.each(this.options, $.proxy(function (i, o) {
          if (this.val === o.Key) {
            v = this.displayField ? o[this.displayField] : o.Value
            return false
          }
        }, this))
      }

      return v
    },
    labelCol () {
      return this.labelwidth || 3
    }
  },
  mounted () {
    this.init()
  },
  updated () {
    // this.init() // Casue unresponsive
  },
  watch: {
    value: function (val) {
      this.val = val || []
      $(this.$refs.select).val(this.val).trigger('change')
      this.setValid(this.isFieldValid())
    },
    readonly: function (val) {
      if (!val) {
        this.initSelect2()
        $(this.$refs.select).next('.select2-container').show()
      } else {
        $(this.$refs.select).next('.select2-container').hide()
      }
    }
  }
}
</script>
<style>
.select2-container {
    width: 100% !important;
}
.select2-selection--single .select2-selection__arrow:after {
  margin-right: 10px;
}
.select2-selection__placeholder {
  font-size: 0.8rem;
}
.select2-selection__rendered {
  padding-left: 13px !important;
  padding-top: 2px;
}
/* .select2-selection.select2-selection--single {
  min-height: 35px;
} */
/* .select2-selection--single {
  padding: 5px 0;
  border-bottom: 0px solid !important;
} */
.select2-search--inline, .select2-search__field {
  width: 100% !important;
}
</style>
